import { render, staticRenderFns } from "./salary-detail-tabs.vue?vue&type=template&id=6cbf5b9e&scoped=true&"
import script from "./salary-detail-tabs.vue?vue&type=script&lang=js&"
export * from "./salary-detail-tabs.vue?vue&type=script&lang=js&"
import style0 from "./salary-detail-tabs.vue?vue&type=style&index=0&id=6cbf5b9e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cbf5b9e",
  null
  
)

export default component.exports